module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-ai-406951d6cf7174487b3c931dba56b910.png";